__webpack_require__.p = "/tools/startup-poker/_next/";